// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-message-card {
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.success-icon-container {
  margin-bottom: 20px;
}

.success-header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #000;
}

.success-info-text {
  margin-bottom: 24px;
  color: #3B3F3D;
  line-height: 1.5;
}

.success-button {
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/success-message-card/SuccessMessageCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".success-message-card {\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n}\n\n.success-icon-container {\n  margin-bottom: 20px;\n}\n\n.success-header {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 16px;\n  color: #000;\n}\n\n.success-info-text {\n  margin-bottom: 24px;\n  color: #3B3F3D;\n  line-height: 1.5;\n}\n\n.success-button {\n  margin-top: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
